import { useEffect, useState } from "react";
import { getInlineLoader } from "../Helpers";
import ServiceDetailLayout from "../components/ServiceDetailLayout";
import banner1 from "../assets/filing.png";
import { IoMdDocument, IoMdCheckmark, IoMdWarning } from "react-icons/io";
import Footer from "../ones/Footer";
import TestimonialSlider from "../ones/TestimonialSlider";

export default function FILING() {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready)
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );

  const hero = {
    kicker: "Filing Adjustments",
    title: "TRA Filing Corrections",
    subtitle: "Adjustments, amendments, and clean records",
    description: "We tidy errors, reissue receipts, and resubmit clean statements so your TRA portal stays accurate.",
    image: banner1,
    chips: ["Reconciliation", "Adjustment letters", "Audit ready"],
  };

  const highlights = [
    { icon: <IoMdDocument />, title: "Documented updates", detail: "Every adjustment is backed with reconciliation notes and supporting attachments." },
    { icon: <IoMdCheckmark />, title: "Timely submissions", detail: "Corrections are compiled, approved, and filed before the monthly deadline." },
    { icon: <IoMdWarning />, title: "Liability oversight", detail: "We flag penalties early and recommend payment strategies to avoid interest." },
  ];

  const timeline = [
    { title: "Assess the ledger", detail: "Review submitted statements, receipts, and adjustments history." },
    { title: "Prepare revisions", detail: "Rebuild affected filings, compile narratives, and prep documents." },
    { title: "Submit & confirm", detail: "Lodge amendments on TRA, capture acknowledgments, and archive evidence." },
  ];

  const extra = {
    ctaTitle: "Need filing correction support?",
    ctaCopy: "Contact us for a guided adjustment workflow and TRA submission assurance.",
  };

  return (
    <>
      <ServiceDetailLayout hero={hero} highlights={highlights} timeline={timeline} extra={extra} />
      <TestimonialSlider />
      <Footer />
    </>
  );
}
